import { render, staticRenderFns } from "./BasketPage.vue?vue&type=template&id=04e305f7&scoped=true"
import script from "./BasketPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BasketPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BasketPage.vue?vue&type=style&index=0&id=04e305f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e305f7",
  null
  
)

export default component.exports